import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  hideCustomerCol?: boolean;
};

const ContractingSimplifiedHeader = ({ hideCustomerCol = false }: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // helpers
  const getEffectiveDateClass = () => {
    return hideCustomerCol
      ? "d-none d-sm-block col text-center text-lg-left"
      : "d-none d-lg-block col";
  };

  // render
  return (
    <div className="px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-center">
        <div className="col-7 col-sm pr-3">{tLabels("contractingSimplifiedHeader.identification")}</div>
        {!hideCustomerCol && (
          <div className="d-none d-md-block col pr-3">{tLabels("contractingSimplifiedHeader.customer")}</div>
        )}
        <div className={getEffectiveDateClass()}>{tLabels("contractingSimplifiedHeader.effectiveDate")}</div>
        <div className="d-none d-lg-block col">{tLabels("contractingSimplifiedHeader.createdDate")}</div>
        <div className="col-5 col-sm">
          {tLabels("contractingSimplifiedHeader.contractingState")}
          <span className="d-lg-none">/</span>
          <span className="d-lg-none">{tLabels("contractingSimplifiedHeader.createdDate")}</span>
        </div>
      </div>
    </div>
  );
};

export default ContractingSimplifiedHeader;
